var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-info-panel"},[_c('InfoIcon',{staticClass:"blog-info-panel__icon"}),_vm._v(" "),_c('div',{staticClass:"blog-info-panel__copy",domProps:{"innerHTML":_vm._s(_vm.copy)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }